import status from '../constants/actionStatus';
export default (state = {
    status : status.PENDING,
    data : []
}, action = {}) => {
    switch (action.type) {
        case 'GET_SUB_EXAMS_LIST_WAITING':
            return {
                status : status.PENDING,
                data : action.payload
            };
        case 'GET_SUB_EXAMS_LIST_SUCCESS':
            return action.payload;
        default:
            return state
    }
}